module.exports = __webpack_public_path__ + "img/c80f53232204512b24366634f4e4004.a91dd0fe.jpg";